import cookies from 'js-cookie';
import CONFIG from '@config/';
import COOKIES from '@data/cookie';
import authCookie from './authCookie';

class TokenController {
  static #cookieKey = `${CONFIG.COOKIE_PREFIX_KEY}__${COOKIES.TOKEN}`;

  static get(): User.Token.Base | null {
    const stringifiedToken = authCookie.get(this.#cookieKey);
    return stringifiedToken !== undefined ? JSON.parse(stringifiedToken) : null;
  }
  static remove() {
    authCookie.remove(this.#cookieKey);
    // NOTE: 이전 쿠키도 삭제 (임시 로직) LX-2461
    if (CONFIG.MODE === 'production') {
      [location.host, 'x.loplat.com', '.x.loplat.com', 'beta.x.loplat.com'].forEach((domain) =>
        cookies.remove(this.#cookieKey, { domain })
      );
    }
  }
  static set(newToken: User.Token.Base) {
    authCookie.set(this.#cookieKey, JSON.stringify(newToken), {
      expires: 30, // X/DMP 기본값과 동일
    });
  }
}

export default TokenController;
